"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactOwner = void 0;
var ContactOwner;
(function (ContactOwner) {
    ContactOwner["PARTNER"] = "PARTNER";
    ContactOwner["COMPANY"] = "COMPANY";
})(ContactOwner || (exports.ContactOwner = ContactOwner = {}));
